import React, { Component } from 'react';

class QuickStart extends Component {
  render() {
    return (
      <div className="docs-content">
        <h2 id="first">Content is under construction...</h2>
      </div>
    );
  }
}

export default QuickStart;